module.exports = __webpack_public_path__ + "img/icon_information.570108c5.svg";